import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { RegistroService } from 'src/app/services/registro.service';
import { RolJuegosService } from 'src/app/services/roljuegos.service';

@Component({
  selector: 'app-inicio',
  templateUrl: './inicio.component.html',
  styleUrls: ['./inicio.component.css']
})
export class InicioComponent implements OnInit {
  myControl= new FormControl();
  Equipos: any;
  EquiposBuscados: any;
  Partidos : any;
  Jornadas : any;
  Temporadas : any;
  Categorias : any;
  Fechas : any;
  TablaPosicion : any;
  lastesdGames : any;
  temporadaa = "";
  categoriaID = 4;
  categoria = "";
  temporadaID = 22;
  roljuegoID = 0;
  jornadaID = 269;
  jornada_vista = "";
  placeholderEquipo = "./assets/equipos/placeholder-equipo.png";

  constructor(
    private roljuegos_service : RolJuegosService,
    private registro_service : RegistroService
    ) { }

  ngOnInit(): void {
    this.obtenerJornadaActual();
    this.obtenerCatalogoTemporadas();
    this.buscarJornadas();
    //this.buscarJuegosFiltro();
    this.obtenerCategorias();



  }

  onLogoError(event: any): void {
    if (event && event.target && String(event.target.src).indexOf('placeholder-equipo') === -1) {
      event.target.src = this.placeholderEquipo;
    }
  }

  obtenerJornadaActual(){
    
    this.roljuegos_service.obtenerJornadaActivo()
    .subscribe((object : any) => {
      if(object.ok){
        //alert(object.ok);
        this.temporadaID = object.data[0].TemporadaID;
        this.jornadaID = object.data[0].JornadaID;
        this.jornada_vista = object.data[0].Jornada_Vista;
        this.buscarPartidos(this.categoriaID, this.jornadaID,0);  
        this.recuperaTablaPosiciones(this.temporadaID, this.categoriaID);
        this.EquiposTemporada();
      }else{
        this.jornada_vista = object.message;
      }
    })
  }

  recuperaTablaPosiciones(busTemporadaID:number,busCategoriaID:number){
    let json = {
      TemporadaID : busTemporadaID,
      CategoriaID : busCategoriaID
    };
    
    this.TablaPosicion = [];
    this.roljuegos_service.obtenerStanding(json)
    .subscribe((object : any) => {
      if(object.ok){
        this.TablaPosicion = object.data;
      }
    });

    //this.TablaPosicion = [
    //  { position : 1, foto : "http://127.0.0.1/api_liga/storage/fotos/Equipos/Equipo-1.png", equipo : "SPORTLAND", wins : "153", loses : "30", points : "186"}
    //]
  }

  EquiposTemporada(){
    let json = {
      TemporadaID : this.temporadaID,
    };
   

    this.Equipos = [];
    this.roljuegos_service.equiposTemporada(json)
    .subscribe((object : any) => {
      if(object.ok){
        this.Equipos = object.data;
        this.EquiposBuscados = object.data;
      }
    });
  }
  EquipoSeleccionado(InscripcionID:number){
    this.buscarPartidos(this.categoriaID, this.jornadaID, InscripcionID);

  }

  obtenerCatalogoTemporadas(){
    this.Temporadas = [
      { id : 1, temporada : "TORNEO DE VERANO 2022"},
      { id : 2, temporada : "TORNEO DE VERANO 2021"},
      { id : 3, temporada : "TORNEO DE VERANO 2020"},
    ]
  }

  obtenerCategorias(){
    this.Categorias = [];
    this.registro_service.catalogoCategorias()
    .subscribe((object : any) => {
      if(object.ok){
        this.Categorias = object.data;
      }
    });
  }
  
  mostrarCategoria(catID: number){
    this.buscarPartidos(catID, this.jornadaID,0);
    this.recuperaTablaPosiciones(this.temporadaID,catID);
  }
  
  buscarJornadas(){
    this.Jornadas = [];
    this.roljuegos_service.obtenerJornadas()
    .subscribe((object : any) => {
      if(object.ok){
        this.Jornadas = object.data;
      }
    });
  }

  seleccionarJornadas(jornadaID:number){
    this.buscarPartidos(this.categoriaID, jornadaID,0);
    this.Jornadas = [];
    this.roljuegos_service.obtenerJornadas()
    .subscribe((object : any) => {
      if(object.ok){
        this.Jornadas = object.data;
      }
    });
  }

  buscarPartidos(busCategoriaID:number,busJornadaID:number, busInscripcionID:number){
    let json = {
      JornadaID : busJornadaID,
      CategoriaID : busCategoriaID,
      InscripcionID : busInscripcionID
    };
    
    this.lastesdGames = [];
    this.roljuegos_service.obtenerResultados(json)
    .subscribe((object : any) => {
      if(object.ok){
        this.lastesdGames = object.data;
        this.categoria = object.data[0].categoria;
        this.categoriaID = busCategoriaID;
        
        
      }
    });
  }

  buscarEquipo(){
    this.Equipos = [];
    this.EquiposBuscados.forEach((element : any) => {
      this.Equipos.push({
        "Equipo" : element.Equipo,
        "InscripcionID" : element.InscripcionID
      });
    });
    if(this.myControl.value.length > 0){
      this.Equipos = [];
      this.EquiposBuscados.forEach((element : any) => {
        if(element.Equipo.includes(this.myControl.value.toUpperCase())){ 
          this.Equipos.push({
            "Equipo" : element.Equipo,
            "InscripcionID" : element.InscripcionID
          });
        }
      });
    }
  }
}
